import { render } from "./BillingDetails.vue?vue&type=template&id=3d574b9c&ts=true"
import script from "./BillingDetails.vue?vue&type=script&lang=ts"
export * from "./BillingDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__